<template>
  <router-view id="app"/>
</template>
<script setup>
import { onMounted, ref } from 'vue'

const active = ref(2)

onMounted(() => {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  })
})
</script>

<style>

html {
  font-size: 100px !important;
}

#app {
  min-height: calc(var(--vh, 1vh) * 100);
  background-color: #f8f8f8;
  margin: 0 auto;
  width: 100%;
  font-size: .12rem;
  font-family: 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

:root {
  --text-button: #159BD4; /* Slightly lighter than deep dark for contrast */
  //--bg-node: #2b313a;
  //--bg-node-header: #343b46;
  //--text-primary: #e2e8f0;
  //--text-node-primary: #13171d;
  //--text-node-secondary: #9ca3af;
  //--text-secondary: #9ca3af;
  //--border-node: #4a5568;
  //--accent-blue: #3b82f6;
  //--accent-green: #10b981;
  //--accent-amber: #f59e0b;
  //--accent-pink: #ec4899;

  //--port-color: #6b7280;
  //--port-hover-color: var(--accent-blue);
  //--port-connected-color: var(--accent-green);
}
</style>